import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type OrderAdminAccessState = {
    accessLevel : {
        accessGranted : boolean
    }
}

const initialState : OrderAdminAccessState = {
    accessLevel: {
        accessGranted: false
    }
}

export const orderAdminAccessSlice = createSlice({
    name: 'orderAdminAccess',
    initialState: initialState,
    reducers: {
        updateAccess: (state, action : PayloadAction<boolean>) => {
            state.accessLevel.accessGranted = action.payload;
        }
    }
});

export const {
    updateAccess
} = orderAdminAccessSlice.actions;

export default orderAdminAccessSlice.reducer;